import { render, staticRenderFns } from "./MdRadio.html?vue&type=template&id=a647085e&external"
import script from "./MdRadio.ts?vue&type=script&lang=ts&external"
export * from "./MdRadio.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports